export interface IPlan {
  name: string
  price: number
  content: string[]
  value: 'BASIC' | 'OVERSEA' | 'CUSTOM'
  description?: string
}

const PLANS: IPlan[] = [
  {
    name: '基础方案',
    price: 348,
    content: [
      '美国公司注册证书-加州或者特拉华州',
      '美国联邦税号注册 (FEIN)',
      '美国公司注册代理人 (一年)',
      '美国公司名字重复检测',
      '一站式自助服务',
    ],
    value: 'BASIC',
  },
  {
    name: '境外优选方案',
    price: 498,
    content: [
      '所有基础方案内容',
      '美国银行远程开户',
      '人工联邦税号注册 (FEIN)',
      '30分钟专业人士咨询',
    ],
    value: 'OVERSEA',
  },
  {
    name: '专业定制方案',
    price: 2998,
    content: [
      '所有基础、境外优选方案内容',
      '美国公司股东注册 （C-Corp)',
      '美国公司企业章程',
      '美国公司首年年审',
      '美国公司创始人股票购买协议',
      '美国公司员工保密协议',
      '美国公司员工手册',
      '美国公司员工雇佣合同',
      '美国营业州税号注册 (SEIN)',
      '外州营业许可证（一个）(Business License)',
      '美国公司员工股权分配合同',
      '美国公司常用合同-房屋租赁，外包服务等',
      '融资指导',
      '专业律师全程服务',
    ],
    description: '适合需要律师一对一服务，有在美雇佣员工需求的公司。',
    value: 'CUSTOM',
  },
]

export default PLANS
